<agr-page-toolbar
  [pageTitle]="'feed-profit.overview.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createFeedProfitCalculation()"
  data-test="feed-profit-overview"
>
  <ng-container *ngIf="tableConfig$ | async as tableConfig">
    <agr-table
      *ngIf="(isLoading$ | async) === false"
      [emptyTitle]="'feed-profit.overview.no-calculations.title' | translate"
      [emptyDescription]="'feed-profit.overview.no-calculations.description' | translate"
      emptyImage="assets/images/pigs_001.jpg"
      [config]="tableConfig"
      class="table"
    ></agr-table>
  </ng-container>
</agr-page-toolbar>
